import { Action } from "@ngrx/store";
import { Transacciones } from "../../models/transaccion.model";

export const SET_TRANSACTIONS = '[Transacciones] Set Transacciones ';
export const SET_TRANSACTIONS_DATA = '[Transacciones] Set Transacciones Data ';
export const SET_HAS_TRANSACTIONS = '[Transacciones] Set si hay transacciones ';
export const UNSET_TRANSACTIONS = '[Transacciones] Unset Transacciones';
export const UNSET_TRANSACTIONS_DATA = '[Transacciones] Unset Transacciones Data';
export const UNSET_HAS_TRANSACTIONS = '[Transacciones] Unset si hay transacciones ';

export class SetTransactions implements Action {
  readonly type = SET_TRANSACTIONS;
  constructor(public transaccionesSeteadas: Transacciones | []) {}
}

export class SetHasTransactions implements Action {
    readonly type = SET_HAS_TRANSACTIONS;
    constructor(public hasTransactions: boolean) {}
  }

export class SetTransactionsData implements Action {
    readonly type = SET_TRANSACTIONS_DATA;
    constructor(public transaccionData: any) {}
  }

export class UnsetTransactions implements Action {
    readonly type = UNSET_TRANSACTIONS;
}

export class UnsetTransactionsData implements Action {
    readonly type = UNSET_TRANSACTIONS_DATA;
}

export class UnsetHasTransactions implements Action {
    readonly type = UNSET_HAS_TRANSACTIONS;
}

export type TransactionActions =  SetTransactions
                                | UnsetTransactions
                                | SetTransactionsData
                                | UnsetTransactionsData
                                | SetHasTransactions
                                | UnsetHasTransactions;
